
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ALLERGENS_LIST, DIETS_LIST } from '@/utils/constants';
import { carriesValues as actionCarriesValues } from '@/utils/bulkJob';
import { decodeString, decodeTag } from '@/utils/decoding';
import StandardModal from '@/components/shared/suites/StandardModal.vue';
import InfoBanner from '@/components/shared/suites/InfoBanner.vue';
import Tabs from '@/components/shared/Tabs.vue';
import SelectComponent from '@/components/shared/Select.vue';
import ChipContainer from '@/components/shared/ChipContainer.vue';
import TagPreview from '@/components/shared/TagPreview.vue';

@Component<BulkActionModal>({
	components: {
		StandardModal,
		InfoBanner,
		Tabs,
		SelectComponent,
		ChipContainer,
		TagPreview
	}
})
export default class BulkActionModal extends Vue {
	@Prop({ type: Boolean, required: false, default: false }) private showModal!: boolean;
	@Prop({ type: String, required: true }) private action!: BulkEditAction;
	@Prop({ type: Array, required: false, default: () => [] }) private locationTags!: MenuItemTag[];

	private selectedTab: string = 'assign';
	private selectedValues: string[] = [];
	private tabs: Tab[] = [
		{ key: 'assign', label: this.$t('multi_location_settings.modals.action.assign') },
		{ key: 'unassign', label: this.$t('multi_location_settings.modals.action.unassign') }
	];

	// Only decides whether a value picker is shown — featured/upsell are plain on/off.
	private get carriesValues(): boolean {
		return actionCarriesValues(this.action);
	}

	private get isAssign(): boolean {
		return this.selectedTab === 'assign';
	}

	private get bannerText(): string {
		return this.$t(`multi_location_settings.modals.action.banners.${this.action}_${this.selectedTab}`);
	}

	private get tagOptions(): { text: string; value: string }[] {
		return this.locationTags.map(tag => ({ text: decodeString(tag.name), value: tag.name }));
	}

	private get tagByName(): Record<string, MenuItemTag> {
		const map: Record<string, MenuItemTag> = {};
		this.locationTags.forEach(tag => {
			map[tag.name] = decodeTag(tag);
		});
		return map;
	}

	private get chipOptions(): { label: string; value: string }[] {
		return this.action === 'allergens' ? ALLERGENS_LIST : DIETS_LIST;
	}

	/**
	 * Emit the action half of the job payload. The page adds the locations and items and starts the
	 * job — this modal closes straight away rather than waiting on the result.
	 *
	 * @return {void}
	 */
	private apply(): void {
		this.$emit('apply', {
			action: this.action,
			assign: this.isAssign,
			...(this.carriesValues ? { values: [...this.selectedValues] } : {})
		});
	}
}
